import type { SVGProps } from "react";

interface IAdditionalProps {
  d: string;
  className?: string;
  size?: number;
}

export type IIconProps = IAdditionalProps & SVGProps<SVGSVGElement>;

export default function Icon({ d, size = 24, className = "", ...props }: IIconProps) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
      height={size}
      width={size}
    >
      <path d={d} />
    </svg>
  );
}
